























































import {Component} from "vue-property-decorator";
import CommonBase from "../../CommonBase";
import ContactLink from "@/components/shared/ContactLink.vue";

@Component({
  components: {
    "at-contact": ContactLink
  }
})
export default class NetworkSetup extends CommonBase {
}
